module.exports = __webpack_public_path__ + "2-47.jpg?adf3500f8aca8fffa7b772f36bbf6e08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-47.jpg
// module id = 124
// module chunks = 0